export default __webpack_public_path__ + "static/media/all-icon.e6158daa.png";